export interface PostSEOMeta {
  title: string;
  description: string;
  keywords: string[];
  ogTitle?: string;
}

/**
 * Meta SEO otimizado individualmente para cada post do blog.
 * - title: até 60 caracteres, contém keyword principal + marca
 * - description: 120-160 caracteres, inclui long-tail keywords naturais
 * - keywords: 5-8 termos de cauda longa relevantes ao tema
 */
export const blogSEOMeta: Record<string, PostSEOMeta> = {
  'palestra-silenciosa-treinamentos-corporativos-como-funciona': {
    title: 'Palestra Silenciosa para Treinamentos Corporativos | STIB',
    ogTitle: 'Palestra Silenciosa para Treinamentos Corporativos: Como Capacitar Múltiplas Turmas ao Mesmo Tempo',
    description:
      'Capacite 3 turmas simultâneas no mesmo espaço com palestra silenciosa. Reduza custos de locação em 60% e aumente o engajamento. Guia completo para RH e T&D com checklist e 4 modelos prontos.',
    keywords: [
      'palestra silenciosa treinamento corporativo',
      'múltiplas turmas simultâneas treinamento',
      'redução custo treinamento empresarial',
      'silent conference T&D Brasil',
      'tecnologia audio treinamento RH',
      'capacitação corporativa sem fio',
      'treinamento múltiplos níveis simultâneos',
    ],
  },

  'conferencia-corporativa-como-planejar-guia-completo': {
    title: 'Conferência Corporativa com Silent Conference: Guia | STIB',
    ogTitle: 'Como Organizar Conferência Corporativa com Silent Conference: Guia Passo a Passo do Zero',
    description:
      'Guia passo a passo para organizar conferência corporativa com silent conference: cronograma de 90 dias, gestão de palestrantes, setup técnico e checklist mestre completo para o dia do evento.',
    keywords: [
      'como organizar conferência corporativa',
      'silent conference passo a passo',
      'planejamento conferência empresarial Brasil',
      'guia conferência corporativa 2026',
      'checklist organização evento corporativo',
      'silent conference múltiplos palestrantes',
      'conferência corporativa sem caixas de som',
    ],
  },

  'silent-disco-confraternizacao-empresa-team-building-guia': {
    title: 'Silent Disco para Confraternização Empresarial | Guia RH',
    ogTitle: 'Silent Disco para Confraternização de Empresa e Team Building: Guia Completo para RH',
    description:
      'Como usar silent disco para confraternizações inesquecíveis: 5 formatos, dinâmicas de team building, como incluir todas as gerações e perfis. Guia prático para RH com dicas de logística e orçamento.',
    keywords: [
      'silent disco confraternização empresa',
      'festa silenciosa team building corporativo',
      'confraternização empresa fones de ouvido',
      'silent disco RH evento interno',
      'team building com silent disco',
      'festa empresa inclusiva todas gerações',
      'confraternização corporativa diferente 2026',
    ],
  },

  'silent-disco-casamento-guia-completo-2026': {
    title: 'Silent Disco em Casamentos 2026: Guia Completo para Noivos',
    ogTitle: 'Silent Disco em Casamentos: O Guia Completo para Noivos que Querem uma Festa Inesquecível em 2026',
    description:
      'Guia completo sobre silent disco em casamentos: como funciona, quanto custa em 2026, como agradar todas as gerações com 3 DJs simultâneos e por que os convidados amam os fones coloridos.',
    keywords: [
      'silent disco casamento Brasil',
      'festa silenciosa casamento 2026',
      'silent disco noivos quanto custa',
      'silent disco casamento experiência Brasil',
      'silent disco diferentes gostos musicais casamento',
      'festa casamento sem barulho vizinhos',
      'silent disco ao ar livre casamento',
    ],
  },

  'eventos-corporativos-tendencias-2026': {
    title: '7 Tendências de Eventos Corporativos no Brasil 2026 | STIB',
    ogTitle: 'Eventos Corporativos em 2026: As 7 Tendências que Vão Dominar o Mercado Brasileiro',
    description:
      'As 7 tendências que dominam eventos corporativos no Brasil em 2026: silent conference, eventos híbridos, personalização em escala, sustentabilidade e bem-estar dos participantes. Análise completa.',
    keywords: [
      'tendências eventos corporativos Brasil 2026',
      'mercado de eventos corporativos 2026',
      'silent conference tendência corporativa',
      'eventos híbridos corporativos Brasil',
      'inovação em eventos empresariais',
      'tecnologia eventos corporativos 2026',
      'bem-estar participantes eventos',
    ],
  },

  'locacao-fones-sem-fio-eventos-brasil': {
    title: 'Locação de Fones Sem Fio para Eventos Brasil | STIB',
    ogTitle: 'Locação de Fones Sem Fio para Eventos: Tudo que Você Precisa Saber Antes de Contratar',
    description:
      'Guia completo sobre locação de fones sem fio para eventos no Brasil: tipos de equipamento, 5 critérios para escolher o fornecedor, checklist de contratação e como evitar problemas no dia do evento.',
    keywords: [
      'locação fones sem fio eventos Brasil',
      'aluguel headphones wireless eventos',
      'fones para silent disco locação',
      'locação equipamento conferência silenciosa',
      'fornecedor fones eventos Brasil',
      'checklist contratação fones eventos',
      'fones wireless eventos corporativos São Paulo',
    ],
  },

  'silent-disco-brasil-festa-silenciosa-guia-completo': {
    title: 'Silent Disco Brasil: Guia Completo sobre Festa Silenciosa',
    ogTitle: 'Silent Disco no Brasil: O Guia Completo sobre Festa Silenciosa para Eventos e Entretenimento',
    description:
      'Guia definitivo sobre silent disco no Brasil: o que é festa silenciosa, como funciona, formatos disponíveis, quanto custa e como contratar o serviço certo para sua festa, festival ou evento.',
    keywords: [
      'silent disco Brasil',
      'festa silenciosa Brasil',
      'o que é silent disco',
      'como funciona festa silenciosa',
      'silent disco como contratar Brasil',
      'contratar silent disco São Paulo',
      'silent disco festival evento',
    ],
  },

  'conferencia-silenciosa-silent-conference-brasil-guia-completo': {
    title: 'Conferência Silenciosa Brasil: Guia Silent Conference 2026',
    ogTitle: 'Conferência Silenciosa no Brasil: O Guia Definitivo para Organizar um Silent Conference de Sucesso',
    description:
      'Guia definitivo de conferência silenciosa no Brasil: como funciona, vantagens sobre sistemas convencionais, silent conference multilíngue, logística completa e cases de sucesso reais.',
    keywords: [
      'conferência silenciosa Brasil',
      'silent conference como funciona',
      'conferência silenciosa vs sistema tradicional',
      'silent conference multilíngue Brasil',
      'conferência sem caixas de som',
      'organizar silent conference Brasil',
      'conferência silenciosa cases sucesso',
    ],
  },

  'palestra-silenciosa-o-que-e-como-funciona-guia-completo': {
    title: 'Palestra Silenciosa: O Que É e Como Funciona | Guia STIB',
    ogTitle: 'Palestra Silenciosa: O Que É, Como Funciona e Por Que Seu Evento Precisa Disso',
    description:
      'Descubra o que é palestra silenciosa, como a tecnologia de transmissão sem fio funciona e quais os benefícios reais para congressos, eventos corporativos e festivais no Brasil. Guia completo.',
    keywords: [
      'o que é palestra silenciosa',
      'como funciona palestra silenciosa',
      'palestra silenciosa benefícios evento',
      'silent lecture Brasil',
      'tecnologia palestra sem barulho',
      'palestra silenciosa congresso',
      'contratar palestra silenciosa Brasil',
    ],
  },

  'como-escolher-tecnologia-audio-conferencias-multilingues': {
    title: 'Tecnologia de Áudio para Conferências Multilíngues | STIB',
    ogTitle: 'Como Escolher Tecnologia de Áudio para Conferências Multilíngues: Critérios Essenciais',
    description:
      '5 critérios essenciais para escolher o sistema de áudio ideal para conferências com múltiplos idiomas: canais simultâneos, qualidade de voz, alcance, autonomia de bateria e facilidade de operação.',
    keywords: [
      'tecnologia áudio conferência multilíngue',
      'sistema tradução simultânea evento',
      'fones sem fio conferência idiomas',
      'áudio wireless múltiplos idiomas evento',
      'como escolher equipamento tradução evento',
      'silent conference multilíngue Brasil',
      'transmissão simultânea idiomas conferência',
    ],
  },

  'tecnologia-audio-sem-fio-tendencias-2025': {
    title: 'Áudio Sem Fio para Eventos: Tendências | STIB',
    ogTitle: 'Tecnologia de Áudio Sem Fio para Eventos: As Principais Tendências que Transformam Conferências',
    description:
      'As tendências em áudio sem fio para eventos: IA para tradução automática com 95% de precisão, conectividade ultra-low latency, sustentabilidade e o futuro da experiência sonora em eventos corporativos.',
    keywords: [
      'tecnologia áudio sem fio eventos',
      'tendências áudio wireless eventos corporativos',
      'IA tradução simultânea eventos',
      'inovação tecnologia conferências',
      'fones sem fio alta qualidade eventos',
      'futuro eventos corporativos áudio',
      'sistema áudio sustentável eventos',
    ],
  },
};
